"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
require("./styles.scss");
var Map_1 = require("./map/Map");
var Activities_1 = require("./activities/Activities");
var model_1 = require("../../model");
var component_1 = require("../_shared/worklogs/component");
var PortalPage_1 = require("../_shared/components/PortalPage");
var constants_1 = require("../../constants");
var CalendarBar_1 = require("../_shared/components/calendarBar/CalendarBar");
var layout_1 = require("../_shared/components/layout");
var actions_1 = require("../_shared/weekDays/actions");
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page(props) {
        var _this = _super.call(this, props) || this;
        _this.sortProjectWorkLogs = function (projectWorkLogs) {
            var activities = _this.props.activities;
            if (!activities || !activities.length) {
                return projectWorkLogs;
            }
            return Object.keys(projectWorkLogs)
                .sort(function (a, b) {
                var indexA = activities.findIndex(function (activity) { return activity.project === a; });
                var indexB = activities.findIndex(function (activity) { return activity.project === b; });
                if (indexA < 0) {
                    indexA = 1000;
                }
                if (indexB < 0) {
                    indexB = 1000;
                }
                return indexA > indexB ? 1 : -1;
            })
                .reduce(function (result, key) {
                result[key] = projectWorkLogs[key];
                return result;
            }, {});
        };
        _this.recalculateWorkDay = function () {
            var _a = _this.state, userId = _a.userId, date = _a.date;
            _this.props.recalculateWorkDay(userId, date);
        };
        var userId = _this.props.match.params.id;
        var date = _this.props.match.params.day;
        if (!moment(date).isValid() || moment(date).isAfter(moment())) {
            date = moment().format('YYYY-MM-DD');
        }
        _this.state = {
            date: date,
            userId: userId,
            workDay: _this.getWeekDay(userId, date, _this.props.weekDays),
        };
        return _this;
    }
    Page.prototype.componentDidMount = function () {
        var _a = this.state, userId = _a.userId, date = _a.date, workDay = _a.workDay;
        this.props.getActivities(userId, date);
        if (!workDay) {
            this.props.setSelectedUsers([userId]);
            this.props.getWeeklyWorkDays(date, [userId]);
        }
    };
    Page.prototype.componentWillReceiveProps = function (nextProps) {
        if (!_.isEqual(this.props.weekDays, nextProps.weekDays)) {
            var _a = this.state, userId = _a.userId, date = _a.date;
            this.setState({
                workDay: this.getWeekDay(userId, date, nextProps.weekDays),
            });
        }
    };
    Page.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Load activities after we fetch weekDays
        if (prevProps.isFetchingWeeklyWorkDays
            && !this.props.isFetchingWeeklyWorkDays
            && !this.props.isLoadingActivities) {
            var _a = this.state, userId = _a.userId, date = _a.date;
            this.props.getActivities(userId, date);
        }
    };
    Page.prototype.updateDate = function (date) {
        this.setState({
            date: date,
            workDay: this.getWeekDay(this.state.userId, date, this.props.weekDays),
        });
        this.props.getActivities(this.state.userId, date);
    };
    Page.prototype.getWeekDay = function (userId, date, weekDays) {
        var userWeek = weekDays.find(function (weekdays) {
            return weekdays.user._id === userId;
        }) || { workDays: [], user: userId, is_approved: false };
        var workDay = _.find(userWeek.workDays, function (workDay) {
            return moment(workDay.date).isSame(moment(date), 'day');
        });
        return workDay;
    };
    /** Admins always have it; everyone else needs the per-user flag. */
    Page.prototype.canPreviewGpsProposal = function () {
        var identity = this.props.identity;
        if (!identity) {
            return false;
        }
        if (identity.role === model_1.UserRoles.ADMIN || identity.role === model_1.UserRoles.SUPERADMIN) {
            return true;
        }
        return !!(identity.settings && identity.settings.canPreviewGpsProposal);
    };
    Page.prototype.renderCalendarBar = function () {
        var _this = this;
        return (React.createElement(layout_1.Wrapper, { padding: "8px", className: "detail-header" },
            React.createElement(layout_1.Column, null,
                React.createElement(layout_1.Row, { justifyContent: "space-around", alignItems: "center" },
                    React.createElement(CalendarBar_1.default, { name: "currentDate", date: this.state.date, locale: constants_1.DEFAULT_LANGUAGE, max: moment(this.state.date).endOf('week'), min: moment(this.state.date).startOf('week'), onDateChange: function (date) { return _this.updateDate(date); } })))));
    };
    Page.prototype.renderGPSData = function () {
        var _this = this;
        if (!this.state.workDay) {
            return null;
        }
        if (this.props.isLoadingActivities) {
            return (React.createElement("div", { className: "loading-container", style: { maxHeight: 600 } },
                React.createElement("div", { className: "loading" })));
        }
        var projects = this.state.workDay.projects;
        var activities = this.props.activities;
        return (React.createElement("div", { className: "actions-container" },
            React.createElement("div", null,
                React.createElement(layout_1.Wrapper, { paddingHorizontal: "32px" },
                    React.createElement(Activities_1.default, { activities: activities, projects: projects, isApproved: _.get(this, 'state.workDay.is_approved', false), canPreviewGpsProposal: this.canPreviewGpsProposal(), gpsProposalUrl: "#/gps-proposal/".concat(this.state.userId, "/").concat(this.state.date), recalculateWorkDay: function () { return _this.recalculateWorkDay(); } })),
                React.createElement(layout_1.Margin, { marginHorizontal: "24px" })),
            (!_.isEmpty(this.props.activities)) && (React.createElement(Map_1.default, { activities: activities, projects: projects }))));
    };
    Page.prototype.renderNavigateBackButton = function () {
        var _this = this;
        return (React.createElement(layout_1.Row, null,
            React.createElement("div", null,
                React.createElement(layout_1.Column, { justifyContent: "space-between" },
                    React.createElement("span", { className: "button", onClick: function () { return _this.props.history.goBack(); } }, "Ga Terug")))));
    };
    Page.prototype.renderWorkLogs = function () {
        var workDay = this.state.workDay;
        if (!workDay) {
            return null;
        }
        return React.createElement("div", { className: "fullHeight" },
            React.createElement(layout_1.Margin, { marginVertical: "32px" }),
            React.createElement(component_1.default, { isApproved: workDay.is_approved, isClosed: workDay.is_closed, closeMessage: workDay.close_message, calledBy: 'workDay', projectsGPSHoursMap: workDay.projects, spent_work_time: workDay.spent_work_time, spent_travel_time: workDay.spent_travel_time, date: this.state.date, user: workDay.user, projects: workDay.projects, worklogs: workDay.worklogs || [], startTime: workDay.startTime, startTimeSubmittedAt: workDay.startTimeSubmittedAt, sortProjectWorkLogs: this.sortProjectWorkLogs, timelines: workDay.timelines }));
    };
    Page.prototype.render = function () {
        var _a, _b;
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_HOURS, id: "user-hours-detail", isLoading: this.props.isLoadingWeeklyWorkDays, subPages: ['Uren Lijst', ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.workDay) === null || _b === void 0 ? void 0 : _b.user) ? (0, model_1.getUserFullName)(this.state.workDay.user) : ''] },
            this.renderCalendarBar(),
            React.createElement(layout_1.Wrapper, { className: "fullHeight" },
                React.createElement(layout_1.Margin, { margin: "16px" }),
                this.renderNavigateBackButton(),
                React.createElement(layout_1.Row, { height: "100%" },
                    this.renderWorkLogs(),
                    React.createElement(layout_1.Margin, { marginHorizontal: "24px" }),
                    this.renderGPSData()))));
    };
    return Page;
}(React.Component));
var mapStateToProps = function (_) {
    return {
        weekDays: _.reducer.WeekDaysReducer.weekDays,
        activities: _.reducer.WeekDaysReducer.activities,
        isFetchingWeeklyWorkDays: _.reducer.WeekDaysReducer.isFetchingWeeklyWorkDays,
        isLoadingWeeklyWorkDays: _.reducer.WeekDaysReducer.isLoadingWeeklyWorkDays,
        isLoadingActivities: _.reducer.WeekDaysReducer.isLoadingActivities,
        identity: _.reducer.authentication.user,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    getActivities: function (user, date) { return actions_1.Actions.getActivities(user, date)(dispatch); },
    recalculateWorkDay: function (user, date) { return actions_1.Actions.recalculateWorkDay(user, date)(dispatch); },
    setSelectedUsers: function (userIds) { return actions_1.Actions.setSelectedUsers(userIds)(dispatch); },
    getWeeklyWorkDays: function (date, userIds) {
        return actions_1.Actions.getWeeklyWorkDays(date, 0, userIds.length, null, null, userIds)(dispatch);
    },
}); };
var UserHoursDetailPage = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(Page);
exports.default = UserHoursDetailPage;
